// JavaScript Document
$(document).ready(function() {
	$('img[src*="_off."]').hover(function() {
		if ($(this).hasClass("rollover_off")) {
			return;
		}
		$(this).attr('src', $(this).attr('src').replace('_off.', '_on.'));
	}, function() {
		//ラジオボタンの代わりにイメージを使う場合、ボタンがアクティブならオフに戻らない
		if ($(this).hasClass("rollover_off")) {
			return;
		}
		$(this).attr('src', $(this).attr('src').replace('_on.', '_off.'));
	});
});